export class RolloverRefreshCoordinator {
  private fallbackTimer: ReturnType<typeof setTimeout> | null = null;
  private pendingAuctionIds = new Set<number>();

  constructor(private readonly fallbackDelayMs = 2000) {}

  scheduleFallbackRefresh(
    refreshFn: () => void,
    auctionId?: number | null,
  ): void {
    if (auctionId != null) {
      this.pendingAuctionIds.add(auctionId);
    }

    if (this.fallbackTimer) {
      return;
    }

    this.fallbackTimer = setTimeout(() => {
      this.clearState();
      refreshFn();
    }, this.fallbackDelayMs);
  }

  cancelFallbackOnRealtimeUpdate(auctionId?: number | null): void {
    if (!this.fallbackTimer) {
      return;
    }

    if (auctionId == null) {
      this.cancelFallback();
      return;
    }

    if (this.pendingAuctionIds.size === 0) {
      this.cancelFallback();
      return;
    }

    this.pendingAuctionIds.delete(auctionId);

    if (this.pendingAuctionIds.size === 0) {
      this.cancelFallback();
    }
  }

  cancelFallback(): void {
    if (this.fallbackTimer) {
      clearTimeout(this.fallbackTimer);
    }
    this.clearState();
  }

  dispose(): void {
    this.cancelFallback();
  }

  private clearState(): void {
    this.fallbackTimer = null;
    this.pendingAuctionIds.clear();
  }
}
